import { useQuery } from "@tanstack/react-query";
import { getAirports } from "../../api/apiAirports";

const useGetAirports = (page = 1, perPage = 15, filters = {}) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ["airports", page, perPage, filters],
        queryFn: () => getAirports(page, perPage, filters),
    });

    return {
        airports: data?.data?.items || [],
        meta: data?.data?.meta || {},
        isLoading,
        error,
    };
};

export default useGetAirports;
